import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringsService {
  /**
   * This object should countains most common and app-wide used strings that must be localized
   */
  strings = {
    filter: $localize`Фильтр`,
    cancel: $localize`Отмена`,
    clear: $localize`Очистить`,
    close: $localize`Закрыть`,
    save: $localize`Сохранить`,
    edit: $localize`Редактировать`,
    accept: $localize`Принять`,
    apply: $localize`Применить`,
    continue: $localize`Продолжить`,
    add: $localize`Добавить`,
    date: $localize`Дата`,
    device: $localize`Установка`,
    company: $localize`Компания`,
    makeChanges: $localize`Внести изменения`,
  };

  // actions = {};
  tableFields = {
    name: $localize`Название`,
    country: $localize`Страна`,
    city: $localize`Город`,
    devices: $localize`Установки`,
    phone: $localize`Телефон`,
    user: $localize`Пользователь`,
  };

  constructor() {}
}
